// Vendor
import * as React from 'react';

const Disclaimer: React.FC = () => {
  const classesParagraph = 'tup-body leading-7';

  return (
    <div className="tup-slide">
      <h1 className="mb-8">Disclaimer</h1>
      <p className={classesParagraph}>
        This [Resale Report] contains forward-looking statements. thredUP has
        based these statements largely on its current expectations and
        assumptions, and on information available as of the date of this report.
        However, we operate in a competitive, new, and rapidly changing market.
        New risks may emerge. thredUP assumes no obligation to update any
        forward-looking statements after the date of this report, except as
        required by law.
      </p>
      <p className={classesParagraph}>
        This [Resale Report] also contains estimates and other statistical data
        made by independent parties and by thredUP relating to market size,
        growth and other industry data. This data involves a number of
        assumptions and limitations. thredUP has not independently verified the
        data generated by independent parties and cannot guarantee accuracy or
        completeness. Projections and assumptions about the future performance
        of the markets in which thredUP competes are subject to a high degree of
        uncertainty. These and other factors could cause results or outcomes to
        differ materially from those expressed.
      </p>
    </div>
  );
};

export { Disclaimer };
